import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card pt-4 mb-6 mb-xl-9"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "m-5 badge badge-light-success" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "svg-icon svg-icon-3" }
const _hoisted_8 = { class: "svg-icon svg-icon-3" }
const _hoisted_9 = { class: "svg-icon svg-icon-3" }
const _hoisted_10 = { class: "card-body pt-0 pb-5" }
const _hoisted_11 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_12 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "svg-icon svg-icon-3" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "svg-icon svg-icon-3" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'ive'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.tableTitle), 1),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_5, "Weight " + _toDisplayString(_ctx.weight + '%'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.can('update', 'ive'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-sm btn-flex btn-light-primary me-3",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_edit_group_value",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showEditGroupModal && _ctx.showEditGroupModal(...args)))
                }, [
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen035.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.translate('updateGroup')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.can('create', 'ive'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_new_question_value",
                  type: "button",
                  class: "btn btn-sm btn-flex btn-light-primary me-3",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showCreateQuestionModal && _ctx.showCreateQuestionModal(...args)))
                }, [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen035.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.translate('addNewQuestion')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.can('update', 'ive'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_question_weight_value",
                  type: "button",
                  class: "btn btn-sm btn-flex btn-light-primary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ShowEditWeightModal && _ctx.ShowEditWeightModal(...args)))
                }, [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen035.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.translate('updateQuestionsWeight')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Datatable, {
            loading: _ctx.loading,
            "table-header": _ctx.tableHeader,
            "table-data": _ctx.tableData,
            "rows-per-page": 5,
            total: _ctx.tableData.length,
            "enable-items-per-page-dropdown": false
          }, {
            "cell-id": _withCtx(({ row: option }) => [
              _createTextVNode(_toDisplayString(option.id), 1)
            ]),
            "cell-title": _withCtx(({ row: option }) => [
              _createTextVNode(_toDisplayString(option.title), 1)
            ]),
            "cell-weight": _withCtx(({ row: option }) => [
              _createTextVNode(_toDisplayString(option.weight), 1)
            ]),
            "cell-isActive": _withCtx(({ row: option }) => [
              (option.isActive)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-actions": _withCtx(({ row: option }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2",
                onClick: _withModifiers(($event: any) => (_ctx.goToAnswers(option.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_14, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com007.svg" })
                ])
              ], 8, _hoisted_13),
              _createElementVNode("a", {
                "data-bs-toggle": "modal",
                "data-bs-target": "#kt_modal_edit_question_value",
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2",
                onClick: _withModifiers(($event: any) => (_ctx.editOption(option.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_16, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ])
              ], 8, _hoisted_15),
              (_ctx.can('remove', 'ive'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                    onClick: _withModifiers(($event: any) => (_ctx.toggleStatusOption(option)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                    ])
                  ], 8, _hoisted_17))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading", "table-header", "table-data", "total"])
        ])
      ]))
    : _createCommentVNode("", true)
}